import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../../services/HttpInterceptor';
import {
    RouteComponentProps, Link, Redirect
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import InputForm from '../../site/layout/InputForm';

interface EditCardProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class EditCard extends React.Component<EditCardProps> {

    @observable private card: any;
    @observable private isLoaded = false;
    @observable private redirect = false;
    @observable private validationErrors: string[] = [];
    @observable private activeOptions = [
        { value: 0, label: 'Habilitada' },
        { value: 1, label: 'Deshabilitada' }
    ];

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        const match = this.props.match;
        const id = (match as any).params.id;
        http.get(`/api/card/read/${id}`).then((response) => {
            this.card = response.data;
            this.isLoaded = true;
        })
            .catch((error) => {
                toast.error("Error cargando tarjeta");
            });
    }

    private handleChange = (event: any) => {
        const { name, value } = event.target;
        this.card[name] = value;
    }

    private setValidation = (value: boolean, name: string): void => {
        const error = this.validationErrors.indexOf(name);
        if (value && error === -1) {
            this.validationErrors.push(name);
        } else if (!value && error !== -1) {
            this.validationErrors.splice(error, 1);
        }
    }

    private onSubmit = (): void => {

        if (this.validationErrors.length > 0) {
            toast.error("Hay un error en tu formulario");
            return;
        }

        http.post(`/api/card/update`, JSON.stringify(this.card))
            .then(() => {
                toast.success(`Tarjeta actualizada`);
                this.redirect = true;
            }).catch((error) => {
                if (Array.isArray(error)) {
                    error.forEach((val) => {
                        toast.error(val);
                    })
                } else {
                    toast.error(error);
                }
            });
    }


    render() {
        if (!this.isLoaded) {
            return null;
        }
        if (this.redirect) {
            return <Redirect to="/pagos/tarjetas" />
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">Tarjeta: {this.card.name}</h4>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <Link to={`../tarjetas`}>
                                            <button className="btn btn-danger btn-sm  pull-right">
                                                <i className="material-icons">highlight_off</i>
                                                <div className="ripple-container"></div>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                <InputForm
                                    name="name"
                                    label="Tarjeta"
                                    value={this.card.name}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <div className="row">
                                    <label className="col-sm-2 col-form-label">Estado</label>
                                    <div className="col-sm-10">
                                        <div className="form-group bmd-form-group is-filled">
                                            <select
                                                className="form-control"
                                                name="disabled"
                                                value={this.card.disabled || 0}
                                                onChange={this.handleChange}
                                            >
                                                {this.activeOptions.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <button onClick={this.onSubmit} type="submit" className="btn btn-primary pull-right">Actualizar Tarjeta</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }
}